<template>
  <a :href="to" :class="computedClass" @click.prevent="handleClick">
    <slot />
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { eventBus } from '@/configs/eventBus';

interface InternalLinkProps {
  to: string;
  class?: string;
}

const props = withDefaults(defineProps<InternalLinkProps>(), {
  class: '',
});

const computedClass = computed(() => props.class);

const handleClick = () => {
  eventBus.emit('goto', { path: props.to });
};
</script>

<style scoped>
/* Default link styling - can be overridden by class prop */
a {
  cursor: pointer;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
